/**
 * @generated SignedSource<<8690c84587c66a466022a2811928e671>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarknotificationsviewedPayload",
    "kind": "LinkedField",
    "name": "marknotificationsviewed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkNotificationsViewedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkNotificationsViewedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e78445eaa6d79e3927ca5aa46507250",
    "id": null,
    "metadata": {},
    "name": "MarkNotificationsViewedMutation",
    "operationKind": "mutation",
    "text": "mutation MarkNotificationsViewedMutation(\n  $input: MarknotificationsviewedInput!\n) {\n  marknotificationsviewed(input: $input) {\n    integer\n  }\n}\n"
  }
};
})();

node.hash = "6992520c09aeb660fd7bc9e3f0c9af0e";

module.exports = node;
